module.exports = __webpack_public_path__ + "img/pay-error.28d7dc99.png";